<template>
  <div class="ui-cert-entry-wrapper">
    <img src="./images/entryBg.png" class="bg" />
    <h3 class="cert-name">{{ activityName }}</h3>
    <h1 class="cert-title"></h1>
    <div class="content-wrapper">
      <p class="name">
        <span class="author">{{ author }}</span>
        同学
      </p>
      <p class="content">{{ certContent }}</p>
    </div>
    <div class="award-wrapper">
      <p class="award-name">{{ prizeName }}</p>
      <p class="award-tips">{{ encourageText }}</p>
    </div>
    <div class="bottom">
      <p class="guide-company-wrapper">
        <span class="label">{{ guideCompanyLabel }}</span>
        <span class="guide-company text" v-html="resolveGuideCompany"></span>
      </p>
      <p class="organizer-wrapper">
        <span class="label">{{ organizerLabel }}</span>
        <span class="orgnizer text" v-html="resolveOrganizer"></span>
      </p>
      <p class="date">{{ publicDate }}</p>
    </div>
    <img :src="qrCodeUrl" class="qrcode" />
  </div>
</template>

<script>
export default {
  name: "uiCertEntry",
  props: {
    certName: {
      type: String,
      default: ""
    },
    activityName: {
      type: String,
      default: ""
    },
    certContent: {
      type: String,
      default: ""
    },
    guideCompanyLabel: {
      type: String,
      default: ""
    },
    guideCompany: {
      type: String,
      default: ""
    },
    organizerLabel: {
      type: String,
      default: ""
    },
    organizer: {
      type: String,
      default: ""
    },
    author: {
      type: String,
      default: "XXX"
    },
    prizeName: {
      type: String,
      default: ""
    },
    encourageText: {
      type: String,
      default: ""
    },
    qrCodeUrl: {
      type: String,
      default: ""
    },
    publicDate: {
      type: String,
      default: ""
    }
  },
  computed: {
    resolveGuideCompany() {
      const guideCompany = this.guideCompany || ""
      return guideCompany.replace(/[\n\r]/g, `<br />`)
    },
    resolveOrganizer() {
      const organizer = this.organizer || ""
      return organizer.replace(/[\n\r]/g, `<br />`)
    }
  }
}
</script>

<style lang="scss" scoped>
$scale: 2.5;
.ui-cert-entry-wrapper {
  position: relative;
  width: (2480px / $scale);
  height: (3508px / $scale);
  text-align: center;
  padding: (546px / $scale) (340px / $scale) 0;
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  .cert-name {
    position: relative;
    z-index: 1;
    font-family: FZLANTY_DAJW--GB1-0;
    font-size: (92px / $scale);
    font-weight: normal;
    font-stretch: normal;
    line-height: (92px / $scale);
    letter-spacing: 0px;
    color: #e83830;
    margin-bottom: (54px / $scale);
    min-height: (92px / $scale);
  }
  .cert-title {
    position: relative;
    z-index: 1;
    font-family: FZLANTY_DAJW--GB1-0;
    font-size: (250px / $scale);
    font-weight: normal;
    font-stretch: normal;
    line-height: (250px / $scale);
    letter-spacing: 0px;
    color: #e83830;
    margin-bottom: (200px / $scale);
    height: (250px / $scale);
  }
  .content-wrapper {
    position: relative;
    z-index: 1;
    font-family: SourceHanSansCN-Medium;
    font-size: (79px / $scale);
    font-weight: normal;
    font-stretch: normal;
    line-height: (142px / $scale);
    letter-spacing: 0px;
    color: #000000;
    vertical-align: bottom;
    margin-bottom: (124px / $scale);
    .name {
      text-align: left;
      margin-bottom: (135px / $scale);
      font-family: SourceHanSansCN-Medium;
      font-size: (79px / $scale);
      font-weight: normal;
      font-stretch: normal;
      line-height: (150px / $scale);
      letter-spacing: 0px;
      color: #000000;
      .author {
        font-family: SourceHanSansCN-Medium;
        font-size: (117px / $scale);
        font-weight: normal;
        font-stretch: normal;
        line-height: (117px / $scale);
        letter-spacing: 0px;
        color: #000000;
      }
    }
    .content {
      text-indent: (158px / $scale);
      text-align: left;
      font-family: SourceHanSansCN-Medium;
      font-size: (90px / $scale);
      font-weight: normal;
      font-stretch: normal;
      line-height: (150px / $scale);
      letter-spacing: 0px;
      color: #000000;
    }
  }
  .award-wrapper {
    position: relative;
    z-index: 1;
    text-align: center;
    .award-name {
      font-family: SourceHanSansCN-Medium;
      font-size: (150px / $scale);
      font-weight: normal;
      font-stretch: normal;
      line-height: (150px / $scale);
      letter-spacing: 0px;
      color: #e50012;
      margin-bottom: (64px / $scale);
    }
    .award-tips {
      font-family: SourceHanSansCN-Medium;
      font-size: (79px / $scale);
      font-weight: normal;
      font-stretch: normal;
      line-height: (79px / $scale);
      letter-spacing: 0px;
      color: #000000;
    }
  }
  .bottom {
    position: absolute;
    bottom: (520px / $scale);
    left: (340px / $scale);
    right: (340px / $scale);
    z-index: 1;
    padding: 0 (0px / $scale) 0 (5px / $scale);
    .guide-company-wrapper,
    .organizer-wrapper {
      text-align: left;
      display: flex;
      margin-bottom: (76px / $scale);
      &:last-child {
        margin-bottom: 0;
      }
      .label {
        flex: none;
        font-family: SourceHanSansCN-Bold;
        font-size: (67px / $scale);
        font-weight: normal;
        font-stretch: normal;
        line-height: (96px / $scale);
        letter-spacing: 0px;
        color: #e83830;
        margin-right: (121px / $scale);
      }
      .text {
        font-family: SourceHanSansCN-Medium;
        font-size: (67px / $scale);
        font-weight: normal;
        font-stretch: normal;
        line-height: (96px / $scale);
        letter-spacing: 0px;
        color: #000000;
      }
    }
    .date {
      position: relative;
      z-index: 1;
      text-align: right;
      font-family: SourceHanSansCN-Medium;
      font-size: (75px / $scale);
      font-weight: normal;
      font-stretch: normal;
      line-height: (125px / $scale);
      letter-spacing: 0px;
      color: #000000;
      margin-top: (153px / $scale);
    }
  }
  .qrcode {
    position: absolute;
    bottom: (209px / $scale);
    left: (193px / $scale);
    z-index: 1;
  }
}
</style>
